import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const AccountBankTableFilter = (props) => {
  const [form] = Form.useForm();

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [transactionProcessTypeSelect, setTransactionProcessTypeSelect] = useState({
    data: [],
    loading: false,
  });
  const [transactionTypeSelect, setTransactionTypeSelect] = useState({
    data: [],
    loading: false,
    query: "",
  });
  const [tagSelect, setTagSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getTransactionProcessTypes();
    getTransactionTypes();
    getTags();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getTransactionProcessTypes = () => {
    setTransactionProcessTypeSelect({
      ...transactionProcessTypeSelect,
      loading: true,
    });

    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setTransactionProcessTypeSelect({
        data: response,
        loading: false,
      });
    });
  };

  const getTransactionTypes = () => {
    setTransactionTypeSelect({
      ...transactionTypeSelect,
      loading: true,
    });

    RequestHandler.get(`/AccountTransaction/GetTransactionType`).then((response) => {
      setTransactionTypeSelect({
        data: response,
        loading: false,
      });
    });
  };

  const getTags = () => {
    setTagSelect({
      ...tagSelect,
      loading: true,
    });

    RequestHandler.get(`/TenantTransactionTag/GetTransactionTagList`).then((response) => {
      setTagSelect({
        data: response?.map((item) => item.tag),
        loading: false,
      });
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onTransactionTypeChange = (value) => {
    if (!value) {
      setTransactionTypeSelect({ ...transactionTypeSelect, query: "" });
      return;
    }

    RequestHandler.get(`/AccountTransaction/GetTransactionTypeGroup?id=${value}`).then((response) => {
      if (Array.isArray(response) && response.length > 0) {
        setTransactionTypeSelect({
          ...transactionTypeSelect,
          query: `transactionTypeId in (${response.map((item) => item.id).join(",")})`
        });
      }
    });
  };

  const getTagsQuery = (value) => {
    let query = "";

    value.map((item, index) => {
      if (value.length > 1) {
        if (index == value.length - 1) {
          query += ` transactionTags/any(s:endswith(s, '${item}'))`
        } else {
          query += `transactionTags/any(s:endswith(s, '${item}')) OR `
        }

      } else {
        query += `transactionTags/any(s:endswith(s, '${value}'))`
      }
    });

    return query;
  };

  const onFinish = (values) => {
    let query = "";
    const conditions = [];

    if (values.iban) {
      conditions.push(odata.contains("iban", values.iban));
    }

    const amountQuery = odata.ConditionalRange(
      "amount",
      values.amountMin,
      values.amountMax
    );
    if (amountQuery) conditions.push(amountQuery);

    if (values.dateRange) {
      const [startDate, endDate] = values.dateRange;

      conditions.push(odata.dateRange("transactionDateValue", startDate, endDate));
    }

    if (values.description) {
      conditions.push(odata.contains("description", values.description));
    }

    if (values.transactionProcessTypeValue) {
      conditions.push(`transactionProcessTypeValue eq ${values.transactionProcessTypeValue}`);
    }

    if (values.firmId) {
      conditions.push(`firmId eq ${values.firmId}`);
    }

    if (values.transactionTypeId) {
      conditions.push(transactionTypeSelect.query);
    }

    if (values.tags) {
      conditions.push(getTagsQuery(values.tags));
    }

    if (conditions.length !== 0) {
      query = conditions.join(" and ");
    }

    if (props.onFinishFilter) props.onFinishFilter(query,values);
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="iban" label="Karşı Iban :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    style={{ marginBottom: 0 }}
                    label="Tutar Aralığı :"
                  >
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber style={{ width: "100%" }} min={0} precision={2} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber style={{ width: "100%" }} min={0} precision={2} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="dateRange" label="Tarih Aralığı :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label="Açıklama :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionProcessTypeValue" label="Ödeme / Tahsilat Tipi :">
                    <Select
                      allowClear
                      placeholder="Tümü"
                      loading={transactionProcessTypeSelect.loading}
                    >
                      {transactionProcessTypeSelect.data.map((item) => (
                        <Select.Option key={item.key} value={item.key}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="firmId" label="Cari :" >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionTypeId" label="İşlem Tipi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      onChange={onTransactionTypeChange}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={transactionTypeSelect.loading}
                    >
                      {transactionTypeSelect.data.map((item) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="tags" label="Etiket :">
                    <Select
                      allowClear
                      mode="tags"
                      placeholder="Etiket seçin"
                      loading={tagSelect.loading}
                    >
                      {tagSelect.data.map((i) => <Select.Option key={i}>{i}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Col>

              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default AccountBankTableFilter;
